import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpInternalService } from 'src/app/data/service/http.service';
import { AnalyticsService } from 'src/app/core/service/analytics/analytics.service';
import { UserService } from 'src/app/data/service/user.service';

// SD-1137: User picks how they'll send captures to Synced. Multi-select.
// Bitmask matches Synced.Models.CaptureMethods on the backend.
// None=0, Email=1, Paper=2, Pdf=4, Later=8
interface MethodOption {
  key: 'email' | 'paper' | 'pdf' | 'later';
  bit: number;
  title: string;
  description: string;
}

@Component({
  selector: 'app-step-capture-methods',
  templateUrl: './step-capture-methods.component.html',
  styleUrls: ['./step-capture-methods.component.scss']
})
export class StepCaptureMethodsComponent implements OnInit {
  methods: MethodOption[] = [
    { key: 'email', bit: 1, title: 'Forward from email', description: 'Auto-forward bills and receipts from your inbox.' },
    { key: 'paper', bit: 2, title: 'Snap a photo', description: 'Use our mobile app to capture paper receipts on the go.' },
    { key: 'pdf',   bit: 4, title: 'Upload PDFs', description: 'Drag & drop PDFs from your desktop.' },
    { key: 'later', bit: 8, title: 'I\'ll decide later', description: 'Skip for now — you can change this anytime.' }
  ];
  selected = new Set<string>();
  saving = false;

  constructor(
    private http: HttpInternalService,
    private router: Router,
    private analytics: AnalyticsService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.analytics.capture('capture_methods_view');
  }

  isSelected(key: string): boolean {
    return this.selected.has(key);
  }

  toggle(option: MethodOption, on: boolean): void {
    if (option.key === 'later' && on) {
      // Exclusive with others.
      this.selected.clear();
      this.selected.add('later');
    } else {
      this.selected.delete('later');
      on ? this.selected.add(option.key) : this.selected.delete(option.key);
    }
  }

  get bitmask(): number {
    let m = 0;
    for (const o of this.methods) {
      if (this.selected.has(o.key)) m |= o.bit;
    }
    return m;
  }

  continue(): void {
    if (this.selected.size === 0 || this.saving) return;
    this.saving = true;
    const organizationId = localStorage.getItem('SelectedOrganization');
    const userId = localStorage.getItem('Id');
    const selectedKeys = Array.from(this.selected);

    this.http.postRequest<any>('Account/SetCaptureMethods', JSON.stringify({
      organizationId,
      captureMethods: this.bitmask
    })).subscribe(
      () => {
        this.analytics.capture('capture_methods_selected', {
          organization_id: organizationId,
          methods: selectedKeys,
          capture_methods_bitmask: this.bitmask
        });
        this.http.postRequest<any>('Account/UpdateOnboardingStep', JSON.stringify({
          userId,
          step: 3
        })).subscribe(() => {}, () => {});
        localStorage.setItem('OnboardingStep', '3');
        // PR-FE4: push the fresh bitmask into UserService so empty-states update now.
        this.userService.loadCaptureMethods(organizationId);

        // SD-1137: capture-methods now returns to the dashboard. The email / mobile
        // setup screens are reached from the dashboard checklist card when applicable.
        this.router.navigate(['/dashboard'], {
          queryParams: { OrganisationId: organizationId, Domain: 'None' }
        });
      },
      () => { this.saving = false; }
    );
  }
}
